import { takeLatest, put, all, call } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, putApi } from 'services/rotasp/api';
import { PATH_AAC_API } from 'services/rotasp/path';

// STORE
import { ReducerActionRotaSP } from 'store/modules/types';

// ACTIONS
import {
	atualizarAtendenteSuccess,
	atualizarAtendenteFailure,
} from './actions';

// TYPES
import { Types, RequestAtualizarAtendente } from './types';
import { ConsultaUsuarioPendente } from '../consultaUsuarioPendente/types';

function* atualizarAtendenteRequest(request: ReducerActionRotaSP) {
	const { token, payload }: { token?: string; payload: any } = request;

	const {
		atualizacao,
		resultado,
	}: {
		atualizacao: RequestAtualizarAtendente;
		resultado: ConsultaUsuarioPendente[];
	} = payload;

	const response: ApiResponse = yield call(
		putApi,
		token || '',
		PATH_AAC_API,
		`central-liberacao/atendimentos/liberados`,
		{},
		atualizacao,
	);

	if (response.status === 200) {
		yield put(atualizarAtendenteSuccess(response.data, resultado));
	} else if (response.error) {
		yield put(atualizarAtendenteFailure());
	}
}

export default all([
	takeLatest(Types.ATUALIZAR_ATENDENTE, atualizarAtendenteRequest),
]);
